import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { BOOK_DEMO_URL } from '../../../data/dgpt';
import { DEPLOYMENT_CONFIG, DEPLOYMENT_OPTIONS, DEPLOYMENT_STEPS } from '../../../data/customBuilder';
import { SectionHeading } from '../../ui/SectionHeading';
import { Reveal } from '../../ui/Reveal';
import { CtaButton } from '../../ui/CtaButton';
export function DeploymentSection() {
  return <section aria-labelledby="deployment-heading" className="border-b border-hairline-soft bg-ink" data-id="element-283" data-mp="133b91x886ruw">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-284" data-mp="180unoy8u56nd">
        <SectionHeading eyebrow="Enterprise deployment" headingId="deployment-heading" title="From Prototype to Production. With Governance Built In." data-id="element-285" data-mp="1crt9uegi8yyj" />

        <ol className="mt-12 grid gap-2 sm:grid-cols-2 lg:grid-cols-7" aria-label="Deployment lifecycle" data-id="element-286" data-mp="1ltj8o5cpv06c">
          {DEPLOYMENT_STEPS.map((step, index) => <Reveal key={step.label} as="li" delay={index * 0.03} className="rounded-xl border border-hairline bg-panel p-4" data-id="element-287" data-mp="1qq1b2ykkqmfi" data-mpi={index}>
              <span className="font-mono text-[11px] text-lime" data-id="element-288" data-mp="1a9j0lbvydwjw">{String(index + 1).padStart(2, '0')}</span>
              <p className="mt-1 text-base font-semibold text-text-primary" data-id="element-289" data-mp="159y55bfzs6bx">{step.label}</p>
              <p className="mt-1 text-[13px] leading-relaxed text-text-secondary" data-id="element-290" data-mp="10bczgwhz0ug3">{step.detail}</p>
            </Reveal>)}
        </ol>

        <div className="mt-12 grid gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-291" data-mp="1xxk6se5nt0w5">
          <div data-id="element-292" data-mp="1sz8wy3fd6qdx">
            <h3 className="text-lg font-semibold text-text-primary" data-id="element-293" data-mp="1t0tr3rxro7b9">Enterprise configuration</h3>
            <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-294" data-mp="1o80kszmngqx2">
              {DEPLOYMENT_CONFIG.map(item => <li key={item} className="flex items-center gap-2.5 text-sm text-text-primary" data-id="element-295" data-mp="1j964q5g2hggn">
                  <CheckIcon className="h-4 w-4 shrink-0 text-lime" aria-hidden="true" data-id="element-296" data-mp="2gq4snbmxy5qg" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-297" data-mp="a0ugyv3lw8zz">
            <h3 className="text-lg font-semibold text-text-primary" data-id="element-298" data-mp="a2dvoh9m6bzn">Deployment approaches</h3>
            <ul className="mt-4 space-y-2" data-id="element-299" data-mp="e1msxw3v4rzy">
              {DEPLOYMENT_OPTIONS.map(option => <li key={option.name} className="rounded-xl border border-hairline bg-panel px-4 py-3" data-id="element-300" data-mp="a8438n9xwkz">
                  <p className="text-sm font-semibold text-text-primary" data-id="element-301" data-mp="592yl7ult9kx">{option.name}</p>
                  <p className="text-[13px] text-text-secondary" data-id="element-302" data-mp="3mhg4rxn91fao">{option.description}</p>
                </li>)}
            </ul>
            <p className="mt-3 text-xs text-text-tertiary" data-id="element-303" data-mp="3rfhsivvme2sh">Architectural approaches scoped with each organization, not a list of available plans.</p>
          </div>
        </div>

        <CtaButton href={BOOK_DEMO_URL} size="lg" event="enterprise_demo_click" eventParams={{
        placement: 'builder_deployment'
      }} className="mt-10 w-full sm:w-auto" data-id="element-304" data-mp="3ihfr4f7z584o">
          Discuss Enterprise Deployment
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-305" data-mp="1gorly0brsam9" />
        </CtaButton>
      </div>
    </section>;
}